import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { debounceTime, take, switchMap, map, catchError } from 'rxjs/operators';
import { PatientService } from 'src/app/services/patient.service';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MrnValidatorService {
  constructor(private patientService: PatientService) {}

  createMrnAsyncValidator(currentUserId: string | null, clientId: string) {
    return (control: AbstractControl) => {
      if (!control.dirty) {
        return of(null);
      }

      return control.valueChanges.pipe(
        debounceTime(600),
        take(1),
        switchMap((raw) => {
          control.markAsDirty({ onlySelf: true });
          control.markAsTouched({ onlySelf: true });

          const mrn = typeof raw === 'string' ? raw.trim() : '';
          if (!mrn) {
            return of(null);
          }

          return this.patientService.validateMrn(mrn, clientId).pipe(
            take(1),
            map(() => null),
            catchError((err) => {
              if (err.status === 400 && err.error?.existingUser) {
                if (currentUserId && err.error.existingUser.userId === currentUserId) {
                  return of(null);
                }
                return of({ mrnTaken: err.error.existingUser });
              }
              return of({ mrnServerError: true });
            })
          );
        })
      );
    };
  }
}
